const msPerSecond = 1000
const secondsPerMinute = 60
const secondsPerHour = 60 * secondsPerMinute
const secondsPerDay = 24 * secondsPerHour

/**
 * A compact countdown label: "2d 4h", "3h 12m", or "4:09" under an hour.
 * Rounds up so "0:00" only shows once the moment has actually arrived.
 */
export const formatCountdown = (remainingMs: number) => {
    const remainingSeconds = Math.max(0, Math.ceil(remainingMs / msPerSecond))
    const days = Math.floor(remainingSeconds / secondsPerDay)
    const hours = Math.floor((remainingSeconds % secondsPerDay) / secondsPerHour)
    const minutes = Math.floor((remainingSeconds % secondsPerHour) / secondsPerMinute)
    const seconds = remainingSeconds % secondsPerMinute

    if (days > 0) {
        return `${days}d ${hours}h`
    }
    if (hours > 0) {
        return `${hours}h ${minutes}m`
    }
    return `${minutes}:${String(seconds).padStart(2, '0')}`
}

/** "Today at 7:00 PM", "Tomorrow at 7:00 PM", or "Fri, Oct 16 at 7:00 PM", in the viewer's time zone. */
export const formatScheduledAt = (scheduledAtMs: number, nowMs: number) => {
    const scheduledDate = new Date(scheduledAtMs)
    const timeLabel = scheduledDate.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })
    const startOfToday = new Date(nowMs)
    startOfToday.setHours(0, 0, 0, 0)
    const dayDifference = Math.floor((scheduledAtMs - startOfToday.getTime()) / (secondsPerDay * msPerSecond))

    if (dayDifference === 0) {
        return `Today at ${timeLabel}`
    }
    if (dayDifference === 1) {
        return `Tomorrow at ${timeLabel}`
    }
    const dateLabel = scheduledDate.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' })
    return `${dateLabel} at ${timeLabel}`
}
